module.exports = __webpack_public_path__ + "static/media/app-promo.bc395f23.png";